import cx from 'classnames'

export const Container = ({ children, className, ...props }) => (
  <div className={cx('tw:mx-auto tw:w-full tw:max-w-content tw:px-5 tw:mobile:px-4', className)} {...props}>
    {children}
  </div>
)
